import * as React from "react";
import { useMutation, useQueryClient } from "react-query";

import { Resource } from "../Services/ResourceService";

import { UseCRUD } from "./hookTypes";

function useCreate<T extends Resource, K extends Resource = T>({
  service,
  id,
}: UseCRUD<T>) {
  const queryClient = useQueryClient();

  const doCreate = React.useCallback(
    (payload: Partial<T>) => service.create(payload),
    []
  );

  const { mutateAsync: create, isLoading: isCreating } = useMutation(doCreate, {
    onSuccess: () => {
      queryClient.invalidateQueries(service.getQueryKey());
    },
  });

  return {
    create,
    isCreating,
  };
}

export default useCreate;
